import React, { useState, useEffect, useCallback } from 'react';
import Axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import { CardGroup } from 'reactstrap';
import styles from './ByCat.module.css';
import { API_URL } from '../../ApiUrl.js';

function ByCat() {
  let { catId, typeId } = useParams();
  const [arts, setArts] = useState([]);
  const [artsWithSc, setArtsWithSc] = useState([]);
  const [isArtsSc, setIsArtsSc] = useState(false);
  const [error, setError] = useState('');
  const [cat, setCat] = useState('');
  const [type, setType] = useState('');

  const getArtsByCat = useCallback(async () => {
    try {
      const res = await Axios.get(`${API_URL}/api/sculptures`);
      const artsByCat = res.data
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .filter((item) => item.CategoryId === catId && item.TypeId === typeId);

      if (artsByCat.length > 0) {
        setType(artsByCat[0].Type.label);
        setCat(artsByCat[0].Category.label);
        
        // Filtrage intelligent des sous-catégories uniques
        const subCatsOnly = artsByCat.filter(item => item.SousCategory);
        const uniqueSubCats = [];
        const map = new Map();
        for (const item of subCatsOnly) {
          if(!map.has(item.SousCategoryId)){
            map.set(item.SousCategoryId, true);
            uniqueSubCats.push(item);
          }
        }

        if (uniqueSubCats.length > 0) {
          setIsArtsSc(true);
          setArtsWithSc(uniqueSubCats);
        }
        setArts(artsByCat);
      }
    } catch (err) {
      setError("Erreur de chargement des œuvres.");
      console.error(err);
    }
  }, [catId, typeId]);

  useEffect(() => {
    getArtsByCat();
  }, [getArtsByCat]);

  const handleScrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className={styles.byCatStyle}>
      {error && <p className="text-danger text-center">{error}</p>}
      
      <div className="text-center mt-3">
        <h3 className="text-muted">{type}</h3>
        <h2 className="title-centered">{cat}</h2>
      </div>

      <CardGroup className={styles.cardGroup}>
        {isArtsSc ? (
          artsWithSc.map((item) => (
            <div key={item.id} className={styles.cardSizeSubCat}>
              <Link to={`/galery/${item.Type.id}/${item.Category.id}/sc/${item.SousCategory.id}`}>
                <img className={styles.imageSubCat} src={item.imageUrl} alt="" />
                <h3 className={styles.subCatTitle}>{item.SousCategory.label}</h3>
              </Link>
            </div>
          ))
        ) : (
          arts.map((item) => (
            <div key={item.id} className={styles.cardSizeCat}>
              <Link to={`/galery/${item.Type.id}/${item.Category.id}/${item.id}`} onClick={handleScrollToTop}>
                <img className={styles.imageCat} src={item.imageUrl} alt="" />
              </Link>
            </div>
          ))
        )}
      </CardGroup>
    </div>
  );
}

export default ByCat;
